import Config from '../../config';
import AuthEndpoints from './authEndpoints';
import apiClient from '../apiClient';

export const resetPasswordEmailStatus = async ({
  email,
}: {
  email: string;
}) => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${AuthEndpoints.ResetPasswordEmailStatusEndpoint}`,
    {
      email,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response;
};
